<template>
  <div>
    <mdb-tbl sm>
      <mdb-tbl-head>
        <tr class="title" >
          <th>단원명 <add-btn-sm class="mr-1" @click="onAdd">단원추가</add-btn-sm></th>
          <th>학습내용</th>
          <th style="width:100px">훈련시간</th>
          <th style="width:40px"></th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(subject, i) in subjects" :key="i">
          <td><span class="pointer bolder" @click="onEdit(subject)">
            <mdb-icon icon="chalkboard-teacher" />
            {{subject.name}}</span>
          </td>
          <td>{{subject.content}}</td>
          <td>{{subject.totalHours}}</td>
          <td><delete-btn-sm class="mr-1" @click="onDelete(subject)"/></td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <culture-subject-edit :show="modal" v-if="subject" v-model="subject" @ok='onSave' @cancel="onCancel" />
  </div>
</template>
<script>
import { } from 'mdbvue';
import CultureSubjectEdit from './CultureSubjectEdit.vue';
import Subject from '@/models/Subject'
export default {
  components: { CultureSubjectEdit },
  name: 'CultureSubjectsEdit',
  props: ['subjects'],
  data: () => ({
    modal: false,
    subject: undefined
  }),
  methods: {
    async onSave () {
      if (!confirm('저장할까요?')) return
      const _id = this.subject._id
      this.subject = await this.subject.save()
      if (_id) { // 수정
        const ix = this.subjects.findIndex(e => e._id !== this.subject._id)
        this.subjects.splice(ix, 1, this.subject)
      } else { // 추가
        this.subjects.push(this.subject)
      }
      this.onCancel()
    },
    async onDelete (subject) {
      if (!confirm('삭제할까요?')) return
      await subject.delete()
      this.subjects = this.subjects.filter(e => e !== subject)
    },
    onAdd () {
      this.subject = Subject.create('CULTURE', this.$route.query.training)
      this.modal = true
    },
    onEdit (subject) {
      this.subject = new Subject(subject) // this.$clone(subject)
      this.modal = true
    },
    onCancel () {
      this.subject = undefined
      this.modal = false
    }
  }
}
</script>
